module.exports = __webpack_public_path__ + "69c6e0274c8d3781fbcda136f5a14d42.svg";